// extracted by mini-css-extract-plugin
export default {"pagination":"css-4q4AQ+aRgR","paginationContainer__centered":"css-jODUKVtlA+"};